import { render } from "./EmailOtp.vue?vue&type=template&id=0c952835&scoped=true"
import script from "./EmailOtp.vue?vue&type=script&lang=js"
export * from "./EmailOtp.vue?vue&type=script&lang=js"

import "./EmailOtp.vue?vue&type=style&index=0&id=0c952835&scoped=true&lang=css"
import "./EmailOtp.vue?vue&type=style&index=1&id=0c952835&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c952835"]])

export default __exports__